import {useMemo} from "react";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {AnalyzerReportProps} from "@/pages/analyzer/Analyzer.types.ts";
import {buildReportSections} from "@/pages/analyzer/Analyzer.utils.ts";
import {AnalyzerReportHeading} from "@/pages/analyzer/components/AnalyzerReportHeading.tsx";
import {AnalyzerReportSection} from "@/pages/analyzer/components/AnalyzerReportSection.tsx";
import {useAnalyzerContext} from "@/pages/analyzer/hooks/AnalyzerContext.tsx";

import styles from "./AnalyzerReport.module.scss";

export const AnalyzerReport = ({report}: AnalyzerReportProps) => {
  const {user} = useCurrentUserContext();
  const {proposedChecks, recommendedChecks, positionById, proposedGroups, accountUsage, formData} =
    useAnalyzerContext();
  const sections = useMemo(
    () =>
      buildReportSections(
        report,
        proposedChecks,
        user!,
        accountUsage,
        formData,
        recommendedChecks,
        positionById,
        proposedGroups
      ),
    [report, proposedChecks, recommendedChecks, positionById, proposedGroups, user, accountUsage, formData]
  );

  return (
    <div className={styles.report}>
      <AnalyzerReportHeading report={report} />
      <div className={styles.sections}>
        {sections.map((section, index) => (
          <AnalyzerReportSection key={`${section.title}-${index}`} {...section} />
        ))}
      </div>
    </div>
  );
};
